module.exports = __webpack_public_path__ + "static/media/vdbg1.df27099c.jpg";